module.exports = {
  // 留言板
  msg: {
    msg: 'Message',
    tit: 'Message Board',
    holder1:
      'Please enter your message here and we will contact you as soon as possible. (required)',
    holder2: 'Name (required)',
    holder3: 'Telephone (required)',
    holder4: 'Email (required)',
    holder5: 'Company',
    btn: 'Send'
  },
  // 头部
  header: {
    search: {
      placeholder: 'Search info',
      title: 'what are you looking for?'
    }
  },
  homeTxt: 'Home',
  // 导航
  nav: {
    list: [
      {
        url: '/',
        name: 'Home'
      },
      {
        url: '',
        name: 'Company introduction',
        sub: [
          {
            url: '/company',
            name: 'Company Profile'
          },
          {
            url: '/news',
            name: 'Company News'
          },
          {
            url: '/team',
            name: 'Management Team'
          },
          {
            url: '/honor',
            name: 'Enterprise Honor'
          },
          {
            url: '/partner',
            name: 'Partner'
          }
        ]
      },
      {
        url: '',
        name: 'Service',
        sub: [
          {
            url: '/department',
            name: 'Medical Affairs'
          },
          {
            url: '/pharmacovigilance',
            name: 'Pharmacovigilance'
          },
          {
            url: '/statistics',
            name: 'Biostatistics'
          },
          {
            url: '/management',
            name: 'Data management'
          },
          {
            url: '/program',
            name: 'Statistical programming'
          },
          {
            url: '/case',
            name: 'Company case'
          }
        ]
      },
      {
        url: '',
        name: 'Resource Center',
        sub: [
          {
            url: '/report',
            name: 'Industry Training'
          },
          {
            url: '/share',
            name: 'Knowledge Sharing'
          }
        ]
      },
      {
        url: '',
        name: 'Contact us',
        sub: [
          {
            url: '/contactus',
            name: 'Contact information'
          },
          {
            url: '/recruit',
            name: 'Recruitment information'
          }
        ]
      }
    ]
  },
  // 底部
  footer: {
    qrtxt: 'Focus on us'
  },
  pages: {
    prev: 'Prev',
    next: 'Next'
  },

  // 首页
  home: {
    // 关于我们
    aboutUS: {
      title: 'About Us',
      btn: 'View More'
    },
    ourTeam: {
      title: 'Our Team',
      btn: 'View More'
    },
    serve: {
      title: 'Service'
    },
    achievement: {
      title: 'Achievement',
      btn: 'View More'
    },
    contact: {
      title: 'Contact Us'
    }
  },
  // 联系我们
  contactUs: {
    info: {
      tit: 'Contact Us',
      adr: 'Address',
      pos: 'Postal Code',
      tel: 'Tel',
      fax: 'Fax',
      email: 'Email'
    },
    title: 'Office Location',
    seemap: 'consult a map'
  },
  // 招聘
  recruit: {
    title: 'Job Responsibilities',
    placeholder: 'Position',
    btn: 'Apply',
    desc: 'No data',
    loc: 'Please select an area',
    dept: 'Please select a department',
    btn1: 'Upload',

    pop: {
      tit: 'Deliver resume',
      t1: 'Name',
      holder1: 'Please enter your name',
      t2: 'Tel',
      holder2: 'Please enter your phone number',
      t3: 'Email',
      holder3: 'Please enter your email',
      t4: 'Resume',
      holder4: 'Please upload your resume attachment',
      t5: 'Job',
      holder5: 'Please enter the position you are applying for',
      t6: 'Site',
      holder6: 'Please enter the city you are applying for',
      tip: 'Supported formats:. Doc. Docx,PDF, single file cannot exceed 5M',
      btn: 'Confirm sending'
    }
  },
  // 公司简介
  company: {
    tit: 'About R&G US',
    tit1: 'Company History',
    tit2: 'AMIT Business Scope',
    tit3: 'Corporate Culture',
    tit4: 'Corporate Photos',
    tit5: 'Our Vision'
  },

  // 知识分享
  share: {
    btn: 'View Details'
  },
  // 公司案例
  case: {
    tit: 'Case'
  },

  // 搜索结果
  result: {
    txt: 'search results'
  }
}
